import Cookies from 'js-cookie'

const SetCookie = (cookiename, value) => {
  console.log('Setting cookie: ', { cookiename,value })
   Cookies.set(cookiename, value, { expires: 2, secure: true, sameSite: 'strict', path: '/' });
}
export default SetCookie